<template>
  <v-container fluid grid-list-md fill-height style="padding:0px 10px 5px 10px;width:100%;height:100%;">
    <v-layout row>
      <v-flex d-flex md6>
        <v-layout column fill-height style="overflow:auto;">
          <EngineCard v-for="cd in cardData" :key="cd" :cardData="cd"></EngineCard>
        </v-layout>
      </v-flex>
      <v-flex d-flex md6>
        <v-card>
          <v-tabs v-model="tabActive" slider-color="rgb(144,170,218)" style="height:100%;width:100%;">
            <v-tab
                v-for="title in tabTitles"
                :key="title"
                ripple
                active-class='activeTab'
                style="text-transform:none;color:rgb(192,192,192);"
            >
              <span>{{ title }}</span>
            </v-tab>
            <v-tab-item class="tabItem">
              <OpenTickets :tickets="open_tickets"/>
            </v-tab-item>
            <v-tab-item class="tabItem">
              <ClosedTickets :tickets="close_tickets"/>
            </v-tab-item>
          </v-tabs>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import OpenTickets from "./OpenTickets";
import ClosedTickets from "./ClosedTickets";
import EngineCard from '../components/EngineCard';

import {store} from "../main.js";

export default {
  name: "CompanyView",
  components: {
    EngineCard,
    OpenTickets,
    ClosedTickets
  },
  data() {
    return {
      tabActive: 0,
      cardData: [],
      tabTitles: [
        'Open Tickets', 'Closed Tickets'
      ],
      open_tickets: [],
      close_tickets: [],
    }
  },
  props: {
    active: Boolean,
    companyData: Object
  },
  computed: {
    selectedTicketsVessel: function () {
      console.trace(store.selectedTicketsVessel)
      return store.selectedTicketsVessel;
    }
  },
  created() {
  },
  mounted() {
    this.setData();
  },
  destroyed() {
    store.selectedTicketsVessel = '';
  },
  methods: {
    setData() {
      store.selectedTicketsVessel = '';

      this.cardData = [];
      this.open_tickets = [];

      if (!!this.companyData && !!this.companyData.vessels) {
        let vessels = Object.keys(this.companyData.vessels);

        for (let i = 0; i < vessels.length; i++) {
          let vessName = vessels[i];

          let engType = this.companyData.vessels[vessName].engineType;

          let engines = Object.keys(this.companyData.vessels[vessName].engines);

          for (let e = 0; e < engines.length; e++) {
            //bsfc
            let bsfcData = {
              title: 'SFOC',
              unit: 'g/kWh',
              value: this.companyData.vessels[vessName].engines[engines[e]].bsfc,
              format: 1,
              chartOptions: {
                time: {
                  useUTC: false
                },
                chart: {backgroundColor: 'transparent'},
                tooltip: {
                  formatter: function () {
                    return this.points.reduce(function (s, point) {
                      return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                      //}, '<b>' + this.x + '</b>');
                    }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                  },
                  shared: true
                },
                legend: {
                  enabled: false
                },
                title: {text: undefined},
                xAxis: {
                  type: 'datetime',
                  labels: {enabled: false},
                  crosshair: true
                },
                yAxis: {
                  labels: {enabled: false},
                  title: {text: undefined}
                },
                exporting: {
                  enabled: false
                },
                series: [
                  {
                    name: 'Values',
                    type: 'line',
                    data: [],
                    marker: {
                      enabled: false
                    },
                    states: {
                      hover: {
                        enabled: false
                      },
                      normal: {
                        animation: false
                      },
                      inactive: {
                        opacity: 1
                      }
                    }
                  },
                  {
                    name: 'Ref',
                    type: 'line',
                    data: [],
                    marker: {
                      enabled: false
                    },
                    states: {
                      hover: {
                        enabled: false
                      },
                      normal: {
                        animation: false
                      },
                      inactive: {
                        opacity: 1
                      }
                    }
                  }
                ]
              }
            };

            for (let j = 0; j < 96; j++) {
              if (bsfcData.value != -1000)
                bsfcData.chartOptions.series[0].data.push([j, (Math.random() * 2) - 1 + bsfcData.value]);
            }

            //sloc
            let slocData = {
              title: 'SLOC setting',
              unit: 'g/kWh',
              value: this.companyData.vessels[vessName].engines[engines[e]].sloc,
              format: 1,
              chartOptions: {
                chart: {backgroundColor: 'transparent'},
                tooltip: {
                  formatter: function () {
                    return this.points.reduce(function (s, point) {
                      return s + '<br/>' + point.series.name + ': ' + point.y.toFixed(2);
                    }, '<b>' + new Date(this.x).toTimeString().substring(0, 5) + '</b>');
                  },
                  shared: true
                },
                legend: {
                  enabled: false
                },
                title: {text: undefined},
                xAxis: {
                  labels: {enabled: false},
                  crosshair: true
                },
                yAxis: {
                  labels: {enabled: false},
                  title: {text: undefined}
                },
                exporting: {
                  enabled: false
                },
                series: [{
                  name: 'Values',
                  type: 'line',
                  data: [],
                  marker: {
                    enabled: false
                  },
                  states: {
                    hover: {
                      enabled: false
                    },
                    normal: {
                      animation: false
                    },
                    inactive: {
                      opacity: 1
                    }
                  }
                }
                ]
              }
            };

            for (let j = 0; j < 96; j++) {
              if (slocData.value != -1000)
                slocData.chartOptions.series[0].data.push([j, (Math.random() * 0.2) - 0.1 + slocData.value]);
            }

            //fault
            let faultData = {};


            if (Object.keys(this.companyData.vessels[vessName].engines[engines[e]]).includes('lastFault')) {
              faultData.last = this.companyData.vessels[vessName].engines[engines[e]]['lastFault'];
            }

            if (Object.keys(this.companyData.vessels[vessName].engines[engines[e]]).includes('topFault')) {
              faultData.top = this.companyData.vessels[vessName].engines[engines[e]]['topFault'];
            }

            //tickets
            let ticketData = [];

            for (let j = 0; j < 24; j++) {
              ticketData.push({});
            }

            //kpi
            let kpi = Math.round(this.companyData.vessels[vessName].engines[engines[e]].eng_KPI * 100);

            let color = this.companyData.vessels[vessName].engines[engines[e]].eng_KPI_color;

            this.cardData.push({
              name: engType,
              lastUpdate: new Date().toISOString().slice(0, 10),
              vessel: vessName,
              engineKPI: kpi,
              engineColor: color,
              fault: faultData,
              bsfc: bsfcData,
              sloc: slocData,
              tickets: ticketData
            });
          }
        }
      }
    },
  },
  watch: {
    companyData: function () {
      this.setData();
    },
    selectedTicketsVessel: function () {
      console.log(store.selectedTicketsVessel)
      if (store.selectedTicketsVessel.length) {
        this.open_tickets = store.vesselTickets[store.selectedTicketsVessel].open;
        this.close_tickets = store.vesselTickets[store.selectedTicketsVessel].resolved;
      } else {
        this.open_tickets = [];
        this.close_tickets = [];
      }
    }
  }
}
</script>

<style scoped>

.tabItem {
  height: calc(100vh - 128px)
}


</style>

<style>

.activeTab {
  color: rgb(144, 170, 218) !important;
  opacity: 1 !important;
}

</style>
